import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSchool as apiUpdateSchool } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateSchool() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: editSchool, isPending: isUpdate, data: results, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdateSchool(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
            navigate('/schools');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editSchool, isUpdate, error, results };
}
